import { getGlobalData } from "./get-global-data";
import { getGlobalLink, setRegionSelectVisibility } from "./get-global-link";
import { getPopulations, getPostTypeData } from "./get-post-type-data";
import { getRouteData } from "./get-route-data";
import { getTaxonomyData } from "./get-taxonomy-data";
import {
    setSortMode,
    setLocationAccessDenied,
    setFreeServiceVisibility,
    openOutsideAuPopup,
    closeOutsideAuPopup,
    closeNotificationBar,
    openLegacyBrowserPopup,
    closeLegacyBrowserPopup,
    setAssetmentFilterVisibility,
} from "./ui-state";

export const actions = {
    getRouteData,
    getGlobalData,
    getPopulations,
    getTaxonomyData,
    getPostTypeData,
    setSortMode,
    setLocationAccessDenied,
    openOutsideAuPopup,
    closeOutsideAuPopup,
    closeNotificationBar,
    openLegacyBrowserPopup,
    closeLegacyBrowserPopup,
    getGlobalLink,
    setRegionSelectVisibility,
    setFreeServiceVisibility,
    setAssetmentFilterVisibility,
};
